"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactScriptTag = _interopRequireDefault(require("react-script-tag"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var paymill;
var PaymillBridge = /*#__PURE__*/function (_PureComponent) {
  function PaymillBridge(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, PaymillBridge);
    _this = _callSuper(this, PaymillBridge, [props]);
    _this.state = {
      formLoaded: false,
      error: undefined,
      loading: false
    };
    _this.handleScriptError = _this.handleScriptError.bind(_this);
    _this.handleScriptLoad = _this.handleScriptLoad.bind(_this);
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.paymillCallback = _this.paymillCallback.bind(_this);
    window.PAYMILL_PUBLIC_KEY = props.apiKey;
    return _this;
  }
  (0, _inherits2["default"])(PaymillBridge, _PureComponent);
  return (0, _createClass2["default"])(PaymillBridge, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (window.paymill) {
        this.handleScriptLoad();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (paymill && !this.formHasLoaded()) {
        paymill.embedFrame('credit-card-fields', {
          lang: 'en'
        }, this.paymillCallback);
      }
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(e) {
      var _this2 = this;
      e.preventDefault();
      var _this$props = this.props,
        amount = _this$props.amount,
        currency = _this$props.currency,
        email = _this$props.email;
      this.setState({
        loading: true
      });
      paymill.createTokenViaFrame({
        amount_int: amount,
        currency: currency,
        email: email
      }, function (error, result) {
        // Handle error or process result.
        if (error) {
          // Token could not be created, check error object for reason.
          _this2.setState({
            error: error,
            loading: false
          });
        } else {
          // Token was created successfully and can be sent to backend.
          // If you want to log the response in the console
          _this2.props.onSuccess(result.token);
          _this2.setState({
            loading: false
          });
        }
      });
    }
  }, {
    key: "paymillCallback",
    value: function paymillCallback(error) {
      if (error) {
        console.error(error.apierror, error.message);
      } else {
        this.setState({
          formLoaded: true
        });
      }
    }
  }, {
    key: "handleScriptError",
    value: function handleScriptError(error) {
      console.error(error);
    }
  }, {
    key: "formHasLoaded",
    value: function formHasLoaded() {
      if (!this._embed) {
        return false;
      }
      return this._embed && this._embed.innerHTML && this._embed.innerHTML.length > 0;
    }
  }, {
    key: "handleScriptLoad",
    value: function handleScriptLoad() {
      paymill = window.paymill;
      this.forceUpdate();
    }
  }, {
    key: "renderLoadingView",
    value: function renderLoadingView() {
      return /*#__PURE__*/_react["default"].createElement("i", {
        className: "fa fa-circle-o-notch fa-spin fa-3x fa-fw",
        style: {
          margin: 40
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$state = this.state,
        error = _this$state.error,
        formLoaded = _this$state.formLoaded,
        loading = _this$state.loading;
      var _this$props2 = this.props,
        processing = _this$props2.processing,
        amountString = _this$props2.amountString;
      var isLoading = loading || processing;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactScriptTag["default"], {
        src: "https://bridge.paymill.com/",
        onError: this.handleScriptError,
        onLoad: this.handleScriptLoad
      }), /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: this.onSubmit,
        id: "paymillform",
        style: {
          display: formLoaded ? 'block' : 'none'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(div) {
          _this3._embed = div;
        },
        id: "credit-card-fields"
      }), /*#__PURE__*/_react["default"].createElement("input", {
        type: "hidden",
        id: "paymillToken",
        name: "paymillToken"
      }), /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-primary",
        type: "submit",
        disabled: isLoading,
        form: "paymillform"
      }, isLoading ? "Paying ".concat(amountString, "...") : "Pay ".concat(amountString))), !formLoaded && this.renderLoadingView(), error && /*#__PURE__*/_react["default"].createElement("p", {
        style: {
          color: 'red'
        }
      }, error.message));
    }
  }]);
}(_react.PureComponent);
PaymillBridge.propTypes = {
  onSuccess: _propTypes["default"].func.isRequired,
  processing: _propTypes["default"].bool.isRequired,
  amount: _propTypes["default"].number.isRequired,
  currency: _propTypes["default"].string.isRequired,
  email: _propTypes["default"].string.isRequired,
  amountString: _propTypes["default"].string.isRequired,
  apiKey: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = PaymillBridge;